import styled from "styled-components/macro";
import { BREAKPOINT_TABLET } from "../../../constants/constants";

// https://docs.react-joyride.com/

export const BeaconStartTourComponent = props => (
  <BeaconStyles {...props}>
    <span className="innerBeacon" />
    <span className="outerRing" />
    <div className="startMessage">Take a quick tour!</div>
  </BeaconStyles>
);
const BeaconStyles = styled.button`
  background-color: transparent;
  border: 0px;
  border-radius: 0px;
  color: rgb(85, 85, 85);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 8px;
  appearance: none;
  display: inline-block;
  height: 36px;
  position: relative;
  width: 36px;
  z-index: 100;
  .innerBeacon {
    animation: 1.2s ease-in-out 0s infinite normal none running
      joyride-beacon-inner;
    background-color: rgb(255, 0, 68);
    border-radius: 50%;
    display: block;
    height: 50%;
    left: 50%;
    opacity: 0.7;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
  }
  .outerRing {
    animation: 1.2s ease-in-out 0s infinite normal none running
      joyride-beacon-outer;
    border: 2px solid rgb(255, 0, 68);
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    height: 100%;
    left: 0px;
    opacity: 0.9;
    position: absolute;
    top: 0px;
    transform-origin: center center;
    width: 100%;
  }
  .startMessage {
    display: none;
    @media (min-width: ${BREAKPOINT_TABLET}px) {
      display: block;
    }
    color: white;
    white-space: nowrap;
    margin-left: 2em;
    margin-bottom: -2px;
    font-family: "GothamBook";
    letter-spacing: 1px;
  }

  @keyframes joyride-beacon-inner {
    20% {
      opacity: 0.9;
    }

    90% {
      opacity: 0.7;
    }
  }

  @keyframes joyride-beacon-outer {
    0% {
      transform: scale(1);
    }

    45% {
      opacity: 0.7;
      transform: scale(0.75);
    }

    100% {
      opacity: 0.9;
      transform: scale(1);
    }
  }
`;
